<template>
  <div class="subscription-action">
    <button class="subscribe" @click="subscribe" ref="subscribeButton">{{$t('message.subscribe') }}</button>
    <button class="assistance" @click="requestAssistance" ref="assistanceButton" v-if="isAssistance"><span>{{$t('message.assistance') }}</span></button>
    <button class="regulations" @click="requestRegulations" ref="regulationsButton" v-if="isRegulation"><span>{{$t('message.regulations') }}</span></button>
    <button class="result" @click="requestResult" ref="resultButton" v-if="isResult"><span>{{$t('message.result') }}</span></button>
  </div>
  <teleport to="#modals">
    <subscription-process-modal :sub="modalSub" @close="modalSub = null"></subscription-process-modal>
    <subscription-result-modal :sub="modalResult" @close="modalResult = null"></subscription-result-modal>
  </teleport>
</template>
<script lang="ts">
import {defineComponent} from 'vue'
import {useSubscriptionService} from '../store/SubsctiptionService';
import SubscriptionProcessModal from "./subscription-process-modal";
import SubscriptionResultModal from "./subscription-result-modal";
import {SubFact, SubItem} from "../entity/SubData";
import {Language} from "../entity/Core";

function isRegulationPresent(subItem: SubItem, lang: Language = Language.RU) : boolean {
  return !!subItem ? !!SubItem.fact(subItem, SubFact.REGULATION, lang) : false
}

export default defineComponent({
  name: 'SubscriptionAction',
  props: {
    'sub': Object, // SubItem,
    'hasResult': Boolean,
    'defAction': String,
  },
  components: {
    SubscriptionProcessModal,
    SubscriptionResultModal,
  },
  data() {
    return {
      isAssistance: true,
      isRegulation: false,
      isResult: false,
      modalSub: null,
      modalResult: null,
      subscriptionService: null
    }
  },
  watch: {
    sub: function(newVal: SubItem, oldVal: SubItem) {
      // console.info("newval sub " + JSON.stringify(newVal));
      this.doUpdate(newVal, this.hasResult, this.defAction)
    },
    hasResult: function(newVal: Boolean, oldVal: Boolean) {
      this.doUpdate(this.sub, newVal, this.defAction)
    },
    defAction: function(newVal: String, oldVal: String) {
      this.doUpdate(this.sub, this.hasResult, newVal)
    },
  },
  methods: {
    doUpdate: function (sub: SubItem, hasResult: Boolean, defAction: String) {
      const lang = Language[this.$i18n.locale.toUpperCase()];

      let hasRegulation = false;
      if (sub != null) {
        // hasRegulation = !!SubItem.fact(sub, SubFact.REGULATION, lang)
        hasRegulation = isRegulationPresent(sub, lang)
        // this.isAssistance = !this.hasRegulation
      }
      switch (defAction) {
        case 'assistance':
          this.isAssistance = true
          this.isRegulation = false
          this.isResult = false
          break
        case 'regulations':
          if (hasRegulation) {
            this.isRegulation = true
            this.isAssistance = false
          } else {
            this.isRegulation = false
            this.isAssistance = true
          }
          this.isResult = false
          break
        case 'result':
          if (hasResult) {
            this.isResult = true
            this.isRegulation = false
            this.isAssistance = false
          } else {
            this.isAssistance = true
            this.isRegulation = false
            this.isResult = false
          }
          break
        default:
          this.isAssistance = true
          this.isRegulation = hasRegulation
          this.isResult = hasResult
      }
    },
    subscribe() {
      this.modalSub = this.sub;
      // this.subscriptionService.doSubscribe(this.sub.id);
    },
    requestAssistance() {
      this.subscriptionService.doRequestAssistance(this.sub);
    },
    requestRegulations() {
      this.subscriptionService.doRequestRegulations(this.sub);
    },
    requestResult() {
      this.modalResult = this.sub;
    },
  },
  mounted() {
    const lang = Language[this.$i18n.locale.toUpperCase()];
    this.subscriptionService = useSubscriptionService();
    this.doUpdate(this.sub, this.hasResult, this.defAction)
  }
})
</script>
<style lang="scss" scoped>
@import "../../scss/variables";
@import "../../scss/mixins";
.subscribe {
  @include button();
}
.assistance, .regulations {
  &:before {
    @include icon();
    margin-right: 20px;
    background-image: url("data:image/svg+xml;base64,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");

    //margin-right: 0;
    //display: none;
  }

  margin-left: 20px;
  @include button($purple);
}

.result {
  &:before {
    @include icon();
    margin-right: 20px;
    background-image: url("data:image/svg+xml;base64,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");

    //margin-right: 0;
    //display: none;
  }

  margin-left: 20px;
  @include button($purple);
}

//.regulations {
//  margin-left: 20px;
//  @include button($purple);
//}

@mixin hide-text() {
  padding: 0 18px;
  :before {
    margin-right: 0;
    display: inline-block;
  }
  span {
    display: none;
  }
}

.subscription-action {
  display: flex;
  flex-direction: row;
  overflow-x: auto;

  @media (max-width: $screen-sm) {
    align-items: stretch;
    width: 100%;
  }

  .subscribe, .assistance, .regulations, .result {
    &:before {
      width: 25px;
      height: 25px;
      margin-right: 0;
    }
    span {
      //margin-left: 12px;
    }

    font-size: 18px;
    line-height: 22px;
    font-style: normal;
    font-weight: 600;
    font-family: 'Exo 2', sans-serif;
    
    flex: 1;
    height: 50px;
  }

  .subscribe, .assistance, .regulations {
    @media (max-width: 620px) {
      @include hide-text();
    }
  }

  .result {
    @media (max-width: 750px) {
      @include hide-text();
    }
  }

  @media (min-width: 620px) {
    .assistance, .regulations, .result {
      &:before {
        display: none;
      }
    }
  }
}
</style>
